<template>
    <div class="qty-main-wrapper">
        <div class="qty-wrap" id="qty-wrap">
            <div class="controls-container" @click="decriment()">
                <span class="minus-qty"> - </span>
            </div>
            <input
                @focus="$event.target.select()"
                @click="$event.target.select()"
                class="size-row__input" 
                :name="'size-qty-' + sizeTitle" 
                :ref="'bundle-product-' + prIndex"
                maxlength="12" 
                :value="value"
                @change="onChange($event.target.value,'bundle-product-' + prIndex)"
                @childUpdateValues="onParentUpdated"
                type="number"
            >
            
            <div class="controls-container" @click="increment()">
                <span class="plus-qty"> + </span>
            </div>
        </div>
    </div>

</template>

<script>
import { store } from './store'

export default {
    props: {
        modelValue: {
            type: Number,
            required: true
        },
        prIndex: Number,
        product: Object
    },

    data() {
        return {
            store: store,
            qtyIncrement: 25
        }
    },
    computed: {
        value: {
            get() {
                return this.store.bandleProductLists[this.prIndex].qty;
            },
            set(val) {
                this.store.bandleProductLists[this.prIndex].qty = val;
            }
        }
    },
    methods: {
        increment() {
            this.value = this.value + this.qtyIncrement;
            this.$emit('customQtyChange', {value: this.value, prIndex: this.prIndex, prID: this.product.id});
        },
        decriment() {
            if(this.value > this.qtyIncrement) {
                this.value = this.value - this.qtyIncrement;
            }
            // TODO check if need after adding computed prop
            this.$emit('customQtyChange', {value: this.value, prIndex: this.prIndex, prID: this.product.id});
        },
        onChange(value, refValue) {
            console.error("change");
            console.log(value);
            console.log(value < this.qtyIncrement);
            console.log(value % this.qtyIncrement);
            let currValue = 25;
            if(value < 25) {
                console.warn("if");
                currValue = 25;
                
            } else if(value % this.qtyIncrement) {
                console.warn("else if");
                currValue = this.roundValueBy(value, this.qtyIncrement); 
            }

            if(value > 25 && !(value % this.qtyIncrement)) {
                currValue = value;
            }

            console.warn(this.value);
            this.value = currValue;
            this.$refs[refValue].value = currValue;
            console.error("refffffff");
            console.log(refValue);

            this.$emit('customQtyChange', {value: this.value, prIndex: this.prIndex, prID: this.product.id});
        },

        roundValueBy(value, by) {
            return Math.round(parseInt(value) / parseInt(by)) * parseInt(by);
        }
    },
    created() {
        window.jQuery("#calendar-imprint-common-qty").on('change', () => {
            console.log("Bundle hidden input changed in created hook");
            this.$emit('customQtyChange', {value: this.value, prIndex: this.prIndex, prID: this.product.id});
        });

    },
    mounted() {
        this.value = this.modelValue;
        window.jQuery("#calendar-imprint-common-qty").click(() => {
            console.log("Bundle hidden input changed");
            this.$emit('customQtyChange', {value: this.value, prIndex: this.prIndex, prID: this.product.id});
        });
    }
}


</script>

<style>
/*
.qty-wrap input[type=number] {
    width: 46px!important;
    height: 22px!important;
    min-height: unset!important;
}
*/

.qty-main-wrapper {
    display: flex;
    justify-content: center;
}

.qty-wrap {
    display: flex;
    width: 75%;
    margin: 5px;
    flex-direction: row;
    /*flex-wrap: wrap;*/
}

.qty-wrap label {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
}

.qty-wrap label .sub_upcharge {
    font-size: 10px;
    font-weight: 300;
    font-style: italic;
} 

.qty-wrap label span {
    line-height: 17px;
}

.size-row__input {
    height: 22px!important;
    min-height: 22px!important;
    max-height: 22px!important;
    /*max-width: 65px!important;*/
    width: 100%!important;
    margin: 0;
    text-align: center;
}

.controls-container {
    width: 22px;
    height: 22px;
    max-height: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(90, 90, 90);
    cursor: pointer;
    min-width: 22px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.controls-container span {
    color: #fff;
    font-weight: bold;
}

.size-row .qty-wrap {
    display: flex;
    width: 90px;
    margin: 5px;
    flex-wrap: wrap;
}

.qty-wrap label {
    width: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
}

.qty-wrap label .sub_upcharge {
    font-size: 10px;
    font-weight: 300;
    font-style: italic;
} 

.qty-wrap label span {
    line-height: 17px;
}

</style>